import {
    db,
    auth,
} from '../config/firebase';

function loadApplicationData() {
    return new Promise((resolve) => {
        const collection = db.collection('applications');
        const removeListener = auth().onAuthStateChanged((user) => {
            if (user) {
                const getApplication = () => (
                    new Promise((resolvePromise) => {
                        collection
                            .where('customer.uid', '==', user.uid)
                            .get()
                            .then((querySnapshot) => {
                                const applications = [];
                                querySnapshot.forEach((doc) => {
                                    applications.push({
                                        ...doc.data(),
                                        applicationId: doc.id,
                                    });
                                });
                                if (applications.length) {
                                    resolvePromise(applications[0]);
                                } else {
                                    resolvePromise({
                                        customer: {
                                            mail: user.email,
                                            uid: user.uid,
                                        },
                                    });
                                }
                            });
                    })
                );
                const getCustomer = () => (
                    new Promise((resolvePromise) => {
                        const customersCollection = db.collection('customers');
                        customersCollection
                            .doc(user.uid)
                            .get()
                            .then((doc) => {
                                resolvePromise(doc.data());
                            });
                    })
                );
                Promise
                    .all([
                        getApplication(),
                        getCustomer(),
                    ])
                    .then((data) => {
                        resolve({
                            ...data[0],
                            applicantDetails: data[1],
                        });
                    });
            } else {
                const applicationId = localStorage.getItem('applicationId');
                if (applicationId) {
                    collection
                        .doc(applicationId)
                        .get()
                        .then((doc) => {
                            if (doc.exists) {
                                resolve({
                                    ...doc.data(),
                                    applicationId,
                                });
                            } else {
                                resolve(null);
                            }
                        });
                } else {
                    resolve(null);
                }
            }
            removeListener();
        });
    });
}

export default loadApplicationData;



// WEBPACK FOOTER //
// ./src/service/loadApplicationData.js